import { Box, Card, Skeleton } from '@mui/material';
import { profileCardSX, skeletonColor } from '../profileStyles';

const NAME_WIDTHS = ['62%', '48%', '70%', '55%', '66%'];

export const ProfileOrganizationsCardSkeleton = () => {
  return (
    <Card elevation={0} sx={{ ...profileCardSX, height: { xs: 420, md: 340 }, padding: 2.5, overflow: 'hidden' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, marginBottom: 2 }}>
        <Skeleton
          variant="rounded"
          width={32}
          height={32}
          sx={{ backgroundColor: skeletonColor, borderRadius: '9px' }}
        />
        <Skeleton variant="text" width={110} height={22} sx={{ backgroundColor: skeletonColor, flex: 'none' }} />
      </Box>
      <Skeleton
        variant="rounded"
        width="100%"
        height={38}
        sx={{ backgroundColor: skeletonColor, borderRadius: '8px', marginBottom: 1.25 }}
      />
      {NAME_WIDTHS.map((width) => (
        <Box key={width} sx={{ display: 'flex', alignItems: 'center', gap: 1.25, paddingY: 1 }}>
          <Skeleton
            variant="rounded"
            width={28}
            height={28}
            sx={{ backgroundColor: skeletonColor, borderRadius: '7px' }}
          />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={width} height={18} sx={{ backgroundColor: skeletonColor }} />
            <Skeleton variant="text" width="45%" height={14} sx={{ backgroundColor: skeletonColor }} />
          </Box>
        </Box>
      ))}
    </Card>
  );
};
